const SOUND_PREFERENCE_KEY = 'fabrik-chat-attention-sound';
let soundEnabled = true;
let audioContext: AudioContext | undefined;

export function isChatAttentionSoundEnabled() {
  try {
    const stored =
      typeof window === 'undefined' ? null : window.localStorage.getItem(SOUND_PREFERENCE_KEY);
    if (stored !== null) soundEnabled = stored !== 'false';
  } catch {
    // Keep the in-memory preference when storage is unavailable.
  }
  return soundEnabled;
}

export function setChatAttentionSoundEnabled(enabled: boolean) {
  soundEnabled = enabled;
  try {
    window.localStorage.setItem(SOUND_PREFERENCE_KEY, String(enabled));
  } catch {
    // Keep the in-memory preference when storage is unavailable.
  }
}

export function unlockChatAttentionSound() {
  if (typeof AudioContext === 'undefined') return;
  try {
    audioContext ??= new AudioContext();
    if (audioContext.state === 'suspended') void audioContext.resume().catch(() => {});
  } catch {
    // Audio is optional; visual notifications still work.
  }
}

export function playChatAttentionSound() {
  if (typeof AudioContext === 'undefined') return;
  try {
    audioContext ??= new AudioContext();
    const context = audioContext;
    const play = () => {
      if (context.state !== 'running') return;
      const time = context.currentTime;
      const notes = [
        { frequency: 1320, start: time, gain: 0.25, duration: 0.28 },
        { frequency: 1760, start: time + 0.12, gain: 0.22, duration: 0.3 },
      ];
      for (const note of notes) {
        const oscillator = context.createOscillator();
        const envelope = context.createGain();
        oscillator.frequency.setValueAtTime(note.frequency, note.start);
        envelope.gain.setValueAtTime(0.0001, note.start);
        envelope.gain.exponentialRampToValueAtTime(note.gain, note.start + 0.005);
        envelope.gain.exponentialRampToValueAtTime(0.0001, note.start + note.duration);
        oscillator.connect(envelope);
        envelope.connect(context.destination);
        oscillator.start(note.start);
        oscillator.stop(note.start + note.duration);
      }
    };
    if (context.state === 'running') play();
    else
      void context
        .resume()
        .then(play)
        .catch(() => {});
  } catch {
    // Audio is optional; visual notifications still work.
  }
}
